import { FormControl, Tab, Tabs } from "@mui/material";
import "./credit-history.component.scss";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useEffect, useState } from "react";
import { getReportById, searchCreditLog } from "../../services/api.service";
import COIN_IMG from "../../assets/images/currency-coin.png";
import ARROW_IMG from "../../assets/images/arrow-right-sm.png";
import { CreditLogModel } from "../../model/credit-log.model";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import tokenService from "../../services/token.service";
import { ReportModel } from "../../model/report.modelt";

const CreditHistoryComponent = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [startDate, setStartDate] = useState<Date>();
    const [endDate, setEndDate] = useState<Date>();
    const [creditLog, setCreditLog] = useState<CreditLogModel[]>();
    const [activeTab, setActiveTab] = useState<"REPORT" | "TEMPLATE">("REPORT");
    const navigate = useNavigate();

    useEffect(() => {
        getSearchAllCreditLog();
    }, [activeTab])

    const handleDateChange = (value, field) => {
        if (field === "start_date") {
            setStartDate(value);
        } else if (field === "end_date") {
            setEndDate(value);
        }
    }
    const filterDateClick = () => {
        if(startDate && endDate){
            console.log(new Date(startDate).toLocaleDateString() + " , " + endDate);
            getSearchAllCreditLog();
        }
    }
    const formatDateTime = (dateString: string | Date): string => {
        if (!dateString) return "-";

        const date = new Date(dateString);

        // ✅ Convert to DD/MMM/YYYY / HH:MM (24-hour format)
        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
            timeZone: "Asia/Bangkok",
        }).replace(",", " /");
    };
    const getSearchAllCreditLog = () => {

        if(!startDate && !endDate){
            searchCreditLog("","", activeTab).then((res) => {

                if (res.data.is_success) {
                    const result = res.data.credits_log as CreditLogModel[];
                    setCreditLog(result);
                }
    
            })
        }else if(startDate && endDate){
            searchCreditLog(new Date(startDate).toLocaleDateString(), new Date(endDate).toLocaleDateString(), activeTab).then((res) => {

                if (res.data.is_success) {
                    const result = res.data.credits_log as CreditLogModel[];
                    setCreditLog(result);
                }
    
            })
        }
       
    }

    const clickViewMore = (report_id) => {
        if (!report_id) return;
        getReportById(report_id).then((res) => {
            if (res.data.is_success) {
                const report = res.data.data as ReportModel;
                 navigate("/" + tokenService.getHR9CompanyUUID() + "/job/" + report.job_question_id+"/"+report.candidate_detail.candidate_id)
                console.log(res.data);
            }})

    }

    return (
        <>
            <div className="credit-history-control">
                <div className="border-std credit-history-top-control">
                    <span className="topic">ประวัติการใช้เครดิต</span>
                    <span className="sub-topic">สามารถดูประวัติการใช้เครดิตย้อนหลังและดูรายละเอียดการใช้ได้</span>
                    <Tabs
                        className="credit-history-tabs"
                        value={activeTab}
                        onChange={(_, v) => setActiveTab(v)}
                    >
                        <Tab value="REPORT" label="Report Credit" />
                        <Tab value="TEMPLATE" label="Template Credit" />
                    </Tabs>
                    <div className="date-control">
                        <FormControl className={isSubmitting && !startDate ? "input-std date-form-control input-error" : "input-std date-form-control"} fullWidth>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker className="form-date-picker" label={"วันที่เริ่มต้น"} name={"วันที่เริ่มต้น"}
                                        value={dayjs(startDate)}
                                        onChange={(newValue) => handleDateChange(newValue, "start_date")} />
                                </DemoContainer>
                            </LocalizationProvider>
                        </FormControl>
                        <FormControl className={isSubmitting && !endDate ? "input-std date-form-control input-error" : "input-std date-form-control"} fullWidth>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer components={['DatePicker']}>
                                    <DatePicker className="form-date-picker" label={"วันที่สิ้นสุด"} name={"วันที่สิ้นสุด"}
                                        value={dayjs(endDate)}
                                        maxDate={dayjs()} // ✅ Set min date to today
                                        onChange={(newValue) => handleDateChange(newValue, "end_date")} />
                                </DemoContainer>
                            </LocalizationProvider>
                        </FormControl>
                        <Button className="button-std button-submit-date" onClick={filterDateClick}>ค้นหา</Button>
                    </div>
                </div>
                {
                    creditLog && creditLog.length > 0 ?
                        <div className="credit-history-content-control">
                            {
                                creditLog.map((item, index) => {
                                    const isReport = String(item.type || "REPORT").toUpperCase() === "REPORT";
                                    const logType = String(item.type || "").toUpperCase();
                                    const used = Number(item.used_credit ?? 0);
                                    const amountLabel =
                                        logType === "TEMPLATE_REFUND"
                                            ? `+${Math.abs(used || 1)}`
                                            : `-${Math.abs(used)}`;
                                    return (
                                        <div className="border-std credit-item-control" key={index}>
                                            <div className="credit-main-control">
                                                <span className="number-main">{amountLabel}</span>
                                                <img src={COIN_IMG} className="coin-img"></img>
                                            </div>
                                            {activeTab === "REPORT" ? (
                                                <span className="cadndiate-text">{item.candidate_name ? item.candidate_name : item.candidate_id}</span>
                                            ) : (
                                                <span className="cadndiate-text">{item.job_position_name ? item.job_position_name : (item.job_question_id || "-")}</span>
                                            )}
                                            <span className="date-text">{formatDateTime(item.created_at)}</span>
                                            {activeTab === "REPORT" && isReport && (
                                                <div className="view-more-control" onClick={() => clickViewMore(item.report_id)}>
                                                    <span className="text">ดูรายงาน</span>
                                                    <img src={ARROW_IMG} className="arrow"></img>
                                                </div>
                                            )}
                                        </div>
                                    )
                                })
                            }
                        </div> : <div className="credit-history-empty-control">
                            <img src={COIN_IMG} className="credit-history-icon"></img>
                            <span className="credit-history-text">
                                {activeTab === "REPORT" ? "ยังไม่มีประวัติการใช้ Report Credit" : "ยังไม่มีประวัติการใช้ Template Credit"}
                            </span>
                        </div>
                }

            </div>
        </>
    )
}

export default CreditHistoryComponent;